import { React } from "react";

const ProfilePage = (props) => {
  return (
    <div>
      <div>
        <h1>Welcome</h1>
      </div>
    </div>
  );
};
export default ProfilePage;
